import React from 'react'
import { Link } from 'react-router-dom'
import toc from '../assets/images/psicologo/toc.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${toc})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">TOC</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">TOC</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

  <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El Trastorno Obsesivo-Compulsivo (TOC) es una condición caracterizada por pensamientos intrusivos y repetitivos (obsesiones) que generan ansiedad, y por conductas repetitivas (compulsiones) que la persona realiza para intentar reducir esa ansiedad. Estas conductas ofrecen un alivio temporal, pero interfieren de forma significativa en la vida diaria.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el TOC?</h4>
        <p className="text-muted">
          El TOC involucra una hiperactividad en circuitos cerebrales relacionados con el control de pensamientos y la toma de decisiones, especialmente en la corteza orbitofrontal, los ganglios basales y el tálamo. Desde la neuromodulación, se busca regular la actividad excesiva en estas áreas y mejorar la flexibilidad cognitiva, reduciendo la urgencia de realizar las compulsiones.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: tensión muscular, fatiga por conductas repetitivas, problemas de sueño.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: pensamientos intrusivos, duda constante, miedo a que ocurra algo malo si no se realizan ciertos rituales.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: lavado de manos excesivo, verificación repetitiva, orden compulsivo, acumulación innecesaria.
        </p>
        <br />
        
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): aplicada a la corteza prefrontal para disminuir la hiperactividad relacionada con las obsesiones.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): estimulación en áreas específicas para mejorar el control inhibitorio.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para promover patrones cerebrales más flexibles y menos reactivos.
        </p>
      </div>
    </div>
  </div>
</section>

    <Footer/>
    </>
  )
}
